import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GroupTreeNode } from 'src/app/hickory-api';
import { AuthorizationViewModel, AuthZDialogData } from '../shared/shared-authz-models';


@Component({
  selector: 'app-add-group-authorization',
  templateUrl: './add-group-authorization.component.html',
  styleUrl: './add-group-authorization.component.scss',
  standalone: false
})
export class AddGroupAuthorizationComponent {
  readonly dialogRef = inject(MatDialogRef<AddGroupAuthorizationComponent>);
  readonly data = inject<AuthZDialogData>(MAT_DIALOG_DATA);

  selectedGroups: AuthorizationViewModel[]

  get groupIds(): number[] { return this.data.currentSelection?.map(x => x.id); }

  onGroupsChange(groups: GroupTreeNode[]) {
    this.selectedGroups = groups.map(g => { 
      const group = new AuthorizationViewModel();
      group.id = g.id;
      group.path = g.path;
      group.name = g.name;
      return group;
    });
  }

  onCancel() {
    this.dialogRef.close();
  }

  onGrantAccess() {
    this.dialogRef.close({ selected: this.selectedGroups });
  }
}
